module.exports = __webpack_public_path__ + "img/ludinam-benevoles.efe33c99.jpg";